const Cheesy = () => {
  return (
    <section className="cheesy">
      <br />
      <label for="cheese">
        <strong>Would you like to add cheese?</strong>
      </label>
      <br />
      <br />
      <div className="cheese-choice">
        <input className="yes" name="cheese" type="radio" value="yes"></input>
        <label for="yes">Yes</label>
        <input className="no" name="cheese" type="radio" value="no"></input>
        <label for="no">No</label>
      </div>
      <br />
      <br />
    </section>
  );
};

export default Cheesy;
